const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]'])

function isLoopbackHost(hostname: string): boolean {
  return LOOPBACK_HOSTS.has(hostname.toLowerCase())
}

/**
 * Rewrites graft websocket URLs for the current runtime.
 *
 * - Browser on a non-loopback host (e.g. Next.js "Network" URL) cannot reach ws://localhost;
 *   use the page hostname so Docker-mapped ports stay reachable.
 * - Browser on Windows often resolves "localhost" to ::1 while Docker publishes IPv4 only;
 *   prefer 127.0.0.1 when the page is also loopback.
 */
export function adaptGraftWebsocketUrlForRuntime(url: string | undefined): string | undefined {
  if (!url) return undefined
  if (typeof window === 'undefined') return url

  try {
    const parsed = new URL(url)
    const pageHost = window.location.hostname

    if (!isLoopbackHost(pageHost) && isLoopbackHost(parsed.hostname)) {
      parsed.hostname = pageHost
      return parsed.toString()
    }

    if (parsed.hostname === 'localhost') {
      parsed.hostname = '127.0.0.1'
      return parsed.toString()
    }
  } catch {
    return url.replace('//localhost', '//127.0.0.1')
  }

  return url
}
